import React, { useState } from "react";

const GroupDataTableRow = ({ label, type, notes }) => {
  const state = useState([{ description: "", value: "" }]);
  const error = useState(false);

  return {
    title: label,
    state,
    error,
    ...(notes && { tooltipText: notes }),
    ...(type && { valueType: type }),
  };
};

export default GroupDataTableRow;
